import { colors } from 'ui/theme';
import { CustomNode } from '../../../types';

export const MODIFYFLOW_ACCENT_COLOR = colors.purple50;
export const MODIFYFLOW_BACKGROUND_ACCENT_COLOR = colors.purple50;
export const MODIFYFLOW_BORDER_ACCENT_COLOR = colors.purple50;
export const MODIFYFLOW_DEFAULT_TITLE = 'Modify journey';

export const modifyFlowBaseConfig: CustomNode = {
  getCustomConfig(model) {
    return {
      defaultTitle: MODIFYFLOW_DEFAULT_TITLE,
      accentColor: MODIFYFLOW_ACCENT_COLOR,
      activeBorderColor: MODIFYFLOW_BORDER_ACCENT_COLOR,
      accentColorBackground: MODIFYFLOW_BACKGROUND_ACCENT_COLOR,
      ...this.getNodeConfig(model),
    };
  },

  getNodeConfig() {
    return {};
  },
};
